import { render, staticRenderFns } from "./yearDetail.vue?vue&type=template&id=c0afb8d6&scoped=true"
import script from "./yearDetail.vue?vue&type=script&lang=js"
export * from "./yearDetail.vue?vue&type=script&lang=js"
import style0 from "./yearDetail.vue?vue&type=style&index=0&id=c0afb8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0afb8d6",
  null
  
)

export default component.exports